import React, { useEffect } from "react";
import styled from "styled-components";
import Banner from "../components/homeComponents/Banner";
import Stats from "../components/homeComponents/Stats";
import BestSellingThreePanel from "../components/homeComponents/BestSellingThreePanel";
import AlbanianArt from "../components/homeComponents/AlbanianArt";
import BestSelling from "../components/homeComponents/BestSelling";
import ContactSection from "../components/homeComponents/ContactSection";
import FAQ from "../components/homeComponents/FAQ";
const Home = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  useEffect(() => {
    document.title =
      "BP11 ArtPrints - Printim i fotografive me kualitet të lartë në Pëlhurë";
  }, []);
  return (
    <Container>
      <Banner />
      <Stats />
      <BestSellingThreePanel />
      <AlbanianArt />
      {/* <BestSelling /> */}
      <FAQ />
      <ContactSection />
    </Container>
  );
};
const Container = styled.div`
  background: var(--primaryBackgroundColor);
  color: var(--fontPrimaryColor);
`;

export default Home;
